function NotificationIcon(props) {
  return (
    <svg
      width={30}
      height={30}
      fill="#A8ADB2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15.5 23.25c.962 0 1.75-.788 1.75-1.75h-3.5c0 .962.779 1.75 1.75 1.75zM20.75 18v-4.375c0-2.686-1.435-4.935-3.938-5.53V7.5A1.31 1.31 0 0015.5 6.187 1.31 1.31 0 0014.187 7.5v.595c-2.51.595-3.937 2.835-3.937 5.53V18L8.5 19.75v.875h14v-.875L20.75 18z" />
    </svg>
  )
}

export default NotificationIcon
